export const mapNotificationSettingsFromServer = (data) => ({
    systemNotifyRent: Boolean(data?.system_notify_rent),
    systemNotifyShift: Boolean(data?.system_notify_shift),
    systemNotifyVk: Boolean(data?.system_notify_vk),
    systemNotifyWidget: Boolean(data?.system_notify_widget),
    systemNotifyTariff: Boolean(data?.system_notify_tariff),
    notifyBeforeEndRent: Boolean(data?.notify_before_end_rent),
});
